/*****************************************************************
function:   getOptionGroupForSelection
Desc.:      Obtain the parent option ID for the particular option.
*****************************************************************/
var getOptionGroupForSelection = function(id) {
  var myElement = document.getElementById(id);
  var myLabel = myElement.getAttribute("data-parentID");
  return myLabel;
};

/*****************************************************************
function:   loadCountries
Desc.:      Load Countries from the API.
*****************************************************************/
var loadCountries = function() {
  var nCurrentTry = 0;
  var nTries = 100;

  //First make sure data has been loaded.
  while (!bCountryDataLoaded && nCurrentTry < nTries) {
    sleep(1000);
    nCurrentTry++;
  }

  if (!bCountryDataLoaded) {
    console.error("Failed to load Country Data.");
    return false;
  }

  //Assign the current countries to a previous list.
  arrPrevSelectedCountryCodes = arrSelectedCountryCodes.slice();

  //Display Regions Data.
  initalizeRegionsList();
  // global_all_countries
}; //END loadCountries

/*****************************************************************
function:   initalizeRegionsList
Desc.:      Initialize and displays a list of Regions in the
			Region drop down.
*****************************************************************/

var initalizeRegionsList = function() {
  arrSelectedSubRegions = [];

  //	objCountries = newcountrygroups.concat(objCountries);

  //Obtain the Region List Div.
  var lstRegions = $("#lstRegions");
  //Walk through each region / sub-region to create the regions drop down.
  $.each(objCountries, function(regionIndex, objRegion) {
    //Create an option for a region, but style it like a group.
    var optRegionGroup = $("<option />")
      .val(objRegion.name)
      .text(objRegion.name)
      .attr("id", "_" + objRegion.name)
      .attr("class", "grp")
      .attr("data-parentID", "#");
    lstRegions.append(optRegionGroup);
    $.each(objRegion.value, function(subRegionIndex, objSubRegion) {
      //Add Sub regions to the options group.
      var optSubRegion = $("<option />")
        .val(objSubRegion.name)
        .text(objSubRegion.name)
        .attr("id", objSubRegion.name)
        .attr("data-parentID", objRegion.name);
      lstRegions.append(optSubRegion);
    });
  });

  $(document).trigger({
    type: "countriesListUpdated"
  });

  //Clear all selections.
  lstRegions.val([]);
  var elementClass = [];
  var listNode;
  $.widget("ui.selectmenu", $.ui.selectmenu, {
    _create: function() {
      var element = $(this.bindings[0]);

      $(this.element[0].childNodes).map(function(index, node) {
        if (node.className) {
          elementClass.push(node.className);
        } else {
          elementClass.push("");
        }
      });

      this._super();

      /** Separates parents option from the child items **/
      /* REALLY BAD AND SHOULD REALLY TALK ABOUT THIS CODE HERE. */
      $("#lstRegions option").each(function() {});

      /** /End **/

      return;
    },
    preserveClasses: function(classArray) {
      if (classArray[index] === "grp") {
        $(node).addClass("grp");
      }

      this.menu[0].children;
    } /*** doc: http://api.jqueryui.com/selectmenu/ */,
    _renderItem: function(
      ul,
      item /**[elem, index, value, label, optgroup, disabled] */
    ) {
      var li = $("<li>");

      if ($(item.element[0]).hasClass("grp")) {
        // parent
        $(li).addClass("select-menu-parent");
      } else {
        // child
        $(li).addClass("select-menu-child");
      }
      $(li).text(item.label);
      return li.appendTo(ul);
    }
  });

  $(lstRegions).selectmenu();

  var listNode = "#lstRegions-menu li";
  $(lstRegions)
    .selectmenu("widget")
    .addClass("jQuerySelectButton hollow");
  $(lstRegions)
    .selectmenu("menuWidget")
    .addClass("jQuerySelectMenu hollow");

  window.handleLstRegionsSelectMenuChange = function(e, ui) {
    //Empty the Sub Regions Array.
    arrSelectedSubRegions = [];
    var selected_option = $(this.selectedOptions);
    //If the current selection in a child sub region, add it to the Sub Region Array.

    if (selected_option.attr("data-parentID") != "#") {
      arrSelectedSubRegions.push(this.value);
    } else {
      //A sub region group was selected, find all the sub regions under the group and add them.
      var nCurIndex = selected_option.index() + 1;
      var strCurItemParentId = $("#lstRegions option")
        .eq(nCurIndex)
        .attr("data-parentID");
      var strCurItemVal = $("#lstRegions option")
        .eq(nCurIndex)
        .val();

      //Add all the sub regions until you get to the next parent region.
      while (
        strCurItemParentId != "#" &&
        typeof strCurItemParentId != "undefined"
      ) {
        arrSelectedSubRegions.push(strCurItemVal);

        //Get next item.
        nCurIndex += 1;
        var strCurItemParentId = $("#lstRegions option")
          .eq(nCurIndex)
          .attr("data-parentID");
        var strCurItemVal = $("#lstRegions option")
          .eq(nCurIndex)
          .val();
      }
    }

    //Update Countries List.
    updateCountriesList();
    createCountryListEvent();
  };

  $(lstRegions).on("selectmenuchange", window.handleLstRegionsSelectMenuChange);

  //Set the World as the first.
  $(lstRegions).val(Config.getUniversalString("World"));

  updateCountriesList();

  //If no countries are selected, disable the Next button.
  if (arrSelectedCountryCodes.length == 0) {
    $("#popupNext").prop("disabled", true);
    $("#popupNext").addClass("disabled");
  }

  var createCountryListEvent = function() {
    $(".countriesList").click(function(elem) {
      var countries = [];

      $.each(objCountries, function(regionIndex, regionObject) {
        regionObject.value.map(function(subRegionObject) {
          subRegionObject.value.map(function(countryObject) {
            if ($("#" + countryObject.value).attr("checked")) {
              countries.push(countryObject);
            }
          });
        });
      });

      if (countries.length > 0) {
        $("#countriesOk").attr("disabled", false);
      } else {
        $("#countriesOk").attr("disabled", true);
      }
    });
  };
  createCountryListEvent();
  $(lstRegions).selectmenu("refresh");
};

/*****************************************************************
function:   updateCountriesList
Desc.:      Update the list of countries
*****************************************************************/
window.updateCountriesList = function() {
  //Declare Important Variables.
  var arrOrderedCountriesList = [];

  //Obtain the Countries List.
  var lstCountries = $("#countriesDiv");

  //Clear the Countries List.
  lstCountries.empty();

  //Select Countries by sub regions if they are already selected.
  if (arrSelectedSubRegions.length) {
    $.each(arrSelectedSubRegions, function(key, subRegionName) {
      var groupName = getOptionGroupForSelection(subRegionName);
      var arrSubRegion = nameValueLib.getValue(objCountries, [
        groupName,
        subRegionName
      ]);
      $.each(arrSubRegion, function(index, objCtry) {
        //Add to the ordered list.
        arrOrderedCountriesList.push(objCtry);
      });
    });
  } else {
    //Select all Countries.
    $.each(objCountries, function(regionIndex, regionObject) {
      $.each(regionObject.value, function(subRegionIndex, subRegionObj) {
        $.each(subRegionObj.value, function(countryIndex, countryObj) {
          //Add to the ordered list.
          arrOrderedCountriesList.push(countryObj);
        });
      });
    });
  }

  //Sort the Countries List.
  sortAPIData(arrOrderedCountriesList, ["name"]);

  //Load Countries into the list.
  $.each(arrOrderedCountriesList, function(index, objCtry) {
    //Add Country Checkbox.
    var countryCheck = $("<input/>").attr({
      name: "countriesList",
      class: "countriesList",
      type: "checkbox",
      id: objCtry.value,
      val: objCtry.value,
      text: objCtry.name
      //onclick: "toggleCountry('" + countryCode + "')"
    });
    lstCountries.append(countryCheck);

    //Add Country Label.
    var countryLabel = $("<label for=" + objCtry.value + " />").text(
      objCtry.name + " (" + objCtry.alias + ")"
    );
    lstCountries.append(countryLabel);
    var breakLine = $("<br>");
    lstCountries.append(breakLine);
  });

  //Add onclick listener.
  /*
	$('.countriesList').click(function () {
		//If Checked, add to the selected list.
		if(this.checked) {
			if(arrSelectedCountryCodes.indexOf(this.id) == -1) {
				arrSelectedCountryCodes.push(this.id);
				arrSelectedCountryNames.push($(this).attr('text'));
			}
		}
		else {
   			arrSelectedCountryCodes.splice($.inArray(this.id, arrSelectedCountryCodes), 1);
   			arrSelectedCountryNames.splice($.inArray($(this).attr('text'), arrSelectedCountryNames), 1);
		}

		//If no coutries are selected, disable the Next button.
		if(arrSelectedCountryCodes.length == 0) {
			$("#popupNext").prop('disabled',true);
			$("#popupNext").addClass('disabled');

		}
		else {
			$("#popupNext").prop('disabled',false);
			$("#popupNext").removeClass('disabled');
		}
	});
*/

  //Make sure and select countries that were previously selected.
  $.each(arrSelectedCountryCodes, function(key, value) {
    $("#" + value).prop("checked", true);
  });

  $(document).trigger({
    type: "countriesListUpdated"
  });
}; //END updateCountriesList

$(document).on("click", ".countriesList", function() {
  //If Checked, add to the selected list.
  if (this.checked) {
    if (arrSelectedCountryCodes.indexOf(this.id) == -1) {
      arrSelectedCountryCodes.push(this.id);
      arrSelectedCountryNames.push($(this).attr("text"));
    }
  } else {
    arrSelectedCountryCodes.splice(
      $.inArray(this.id, arrSelectedCountryCodes),
      1
    );
    arrSelectedCountryNames.splice(
      $.inArray($(this).attr("text"), arrSelectedCountryNames),
      1
    );
  }

  //If no coutries are selected, disable the Next button.
  if (arrSelectedCountryCodes.length == 0) {
    $("#popupNext").prop("disabled", true);
    $("#popupNext").addClass("disabled");
  } else {
    $("#popupNext").prop("disabled", false);
    $("#popupNext").removeClass("disabled");
  }
});

/*****************************************************************
function:   toggleCountry
Desc.:
*****************************************************************/
var toggleCountry = function(elemID) {
  var myElem = $("#" + elemID);

  //$("#countriesOk").attr("disabled", true);
};

/*****************************************************************
function: selectAllCountries
Desc.:
*****************************************************************/
var selectAllCountries = function() {
  //Check all the countries.
  $(".countriesList")
    .prop("checked", false)
    .trigger("click");
  $("#countriesOk").attr("disabled", false);
};

/*****************************************************************
function: clearAllCountries
Desc.:
*****************************************************************/
var clearAllCountries = function() {
  $(".countriesList")
    .prop("checked", true)
    .trigger("click");
  $("#countriesOk").attr("disabled", true);
};

$(document).ready(function() {
  (function() {
    var _this = this;
    var rand = function() {
      return Math.floor(Math.random() * 1000000 + 1);
    };

    var _global = (window[["X", rand(), rand(), rand()].join("")] = {});

    _this.newcountrygroups = _(COUNTRY_GROUPS_2020_ITEMS)
      .groupBy("CtryGrpName")
      .values()
      .value()
      .reduce(function(out, current) {
        out[current[0].CtryGrpName] = current;
        return out;
      }, {});

    _this.getSelectedGroup = function() {
      var v = $("div#countryGroupsDiv select").val();
      if (v) {
        return _this.newcountrygroups[v];
      }

      return [];
    };

    _this.fillSelect = function() {
      if ($("div#countryGroupsDiv select option").length) return;

      var isFr = Config.getLanguage() === 'fr';
      var selectLabel = isFr ? 'Sélectionnez le groupe de pays' : 'Select Country Group';

      $("div#countryGroupsDiv select").append(
        '<option value="">' + selectLabel + "</option>"
      );
      _.keys(_this.newcountrygroups).forEach(function(v) {
        var label = isFr ? _this.newcountrygroups[v][0].CtryGrpName_fr : v;
        $("div#countryGroupsDiv select").append(
          '<option value="' + v + '">' + label + "</option>"
        );
      });
    };

    $(document).on("countriesListUpdated", function(e) {
      _this.fillSelect();

      _this.hideCheckboxes();
    });

    $(document).on("change", "div#countryGroupsDiv select", function(e) {
      _this.fillSelect();
      window.updateCountriesList();
      /*
			if(this.value){
				_this.hideCheckboxes();	
			}
			else{
				window.updateCountriesList();
			}
*/
    });

    $(document).on("click", '#parameterPopup [data-toggle="tab"]', function(e) {
      // TODO: remove preventDefault
      //e.preventDefault();
      // reset forms
      var regionsElement = document.getElementById("lstRegions");
      $(regionsElement).val(Config.getUniversalString("World"));
      window.handleLstRegionsSelectMenuChange.bind(regionsElement)();
      $(lstRegions).selectmenu("refresh");
      $("div#countryGroupsDiv select")
        .val("")
        .trigger("change");

      var tabs = $(this).parents(".nav-tabs");
      tabs.find(".active").removeClass("active");
      $(this).addClass("active");
      $(this.hash)
        .parent()
        .find(".tab-pane")
        .hide();
      $(this.hash).show();
    });

    _this.hideCheckboxes = function() {
      var ids = _this.getSelectedGroup().map(function(r) {
        return r.Ctry_Code;
      });
      if (!ids.length) {
        return;
      }
      $("#countriesDiv")
        .find("input")
        .each(function() {
          var val = $(this).attr("val");
          if (ids.indexOf(val) === -1) {
            $(this)
              .nextUntil("input")
              .remove();
            $(this).remove();
          }
        });
    };

    window.hideCheckboxes = _this.hideCheckboxes;
  })();
});
